import { render } from "./Spa_Daily_El.vue?vue&type=template&id=696bde42&ts=true"
import script from "./Spa_Daily_El.vue?vue&type=script&lang=ts"
export * from "./Spa_Daily_El.vue?vue&type=script&lang=ts"

import "./Spa_Daily_El.vue?vue&type=style&index=0&id=696bde42&lang=css"

import exportComponent from "C:\\Users\\AloneX\\taipeitest\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__